import { render, staticRenderFns } from "./NewsDetail1024.vue?vue&type=template&id=28644c52&scoped=true"
import script from "./NewsDetail1024.vue?vue&type=script&lang=js"
export * from "./NewsDetail1024.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail1024.vue?vue&type=style&index=0&id=28644c52&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28644c52",
  null
  
)

export default component.exports